<div class="room-options-container" *ngIf="room">
  <div class="room-info-container">
    <div class="name-room" custom-tooltip [mbTooltipText]="roomName" [wordLimit]="ROOM_NAME_WORDS_LIMIT">
      {{ roomName | titlecase | ellipsis: ROOM_NAME_WORDS_LIMIT }}
    </div>

    <div *ngIf="isExperts && (offerCodesParsed.length > 0)" class="offer-codes">
      <p>
        Codigos de oferta
      </p>
      <mb-badge *ngFor="let code of offerCodesParsed" color="light" size="small">{{ code }}
      </mb-badge>
    </div>
    <hr/>
    <mb-badge color="light" size="small" class="rooms-number">
      {{ isHomestay ? 'Departamento' : 'Habitación ' + numberRoom }}
    </mb-badge>
    <ng-container *ngIf="isHomestay; else hotel">
      <p class="guests guests--homestay" *ngIf="room.total_rooms > 0 || room.bathroomTotal > 0">
        <span *ngIf="room.total_rooms > 0"> {{ room.total_rooms }} habitaciones</span>
        <span *ngIf="room.bathroomTotal > 0"> - {{ room.bathroomTotal }} baños </span>
      </p>
      <mb-icon-text *ngFor="let info of beds_info_filter;let isLast = last" [class.guests--last]="isLast"
        style="align-items:center;">
        <mb-icon icon="sleep"></mb-icon>
        <span class="guests">
          {{ info.quantity }}
          <span>{{ info.name }}</span>
        </span>
      </mb-icon-text>
    </ng-container>
    <ng-template #hotel>
      <mb-icon-text class="hotel-guests">
        <mb-icon icon="login"></mb-icon>
        <span class="guests">{{ room.adults }}
          <span i18n="@@room_adultos">{ room.adults, plural, =1 {Adulto} other {Adultos} }</span>
          <span *ngIf="room?.children?.length !== 0">, {{ room.children.length }}
            <span i18n="@@room_menores">{ room.children.length, plural, =1 {Menor} other {Menores} }</span>
          </span>
        </span>
      </mb-icon-text>
    </ng-template>

    <mb-badge color="light" size="small" class="latest-rooms" *ngIf="mealPlan != 'ROOM_ONLY' && index < 2"
      i18n="@@poca_disponibilidad">Poca disponibilidad
    </mb-badge>
    <mb-badge color="light" size="small" class="latest-rooms" *ngIf="mealPlan != 'ROOM_ONLY' && latestRooms < 2"
      i18n="@@ultimo_disponible">Último disponible
    </mb-badge>
  </div>
</div>